import { render, staticRenderFns } from "./ButtonListManage.vue?vue&type=template&id=16284390&"
import script from "./ButtonListManage.vue?vue&type=script&lang=js&"
export * from "./ButtonListManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports